import {URLS} from "./app-urls";
import {AbstractService, Expands, Filters} from "./abstract-service";
import {AssetControl} from "../models/basic/asset-control";
import {trackPromise} from "react-promise-tracker";
import Api from "./api-config";
import {AxiosResponse} from "axios";
import {Project} from "../models/basic/project";
import {Paginated, PaginatedResult} from "../models/default/paginated-result";
import {StockAndMaterialOutputFilter} from "./stock-and-material-output-service";
import {MonthYearOption} from "../components/multilevel-select-year/multilevel-select-year.component";

export type AssetControlFilter = Filters & {
    project?: string,
    date?: string,
    client?: string,
    ordering?: string,
};

export interface TotalInvoices {
    sum_total: number,
    sum_amtz_qtd: number,
}

export class AssetControlService extends AbstractService<AssetControl> {

    constructor() {
        super(URLS.REPORT_ASSET_CONTROL);
    }

    override processFilters = (filters?: Filters) : Filters | undefined => {
        const processedFilter = {
            ...filters
        };

        if (processedFilter?.client === "0") {
            delete processedFilter.client;
        }

        if(processedFilter.status) {
            if(processedFilter.status === "0") {
                delete processedFilter.status;
            }
        }

        if(processedFilter.active) {
            if(processedFilter.active === "0") {
                delete processedFilter.active;
            } else {
                processedFilter.active = processedFilter.active === "active";
            }
        }

        return processedFilter;
    }


    async listProjects(filters?: AssetControlFilter): Promise<AxiosResponse<Project[]>> {
        const path = `${this.path}/list_projects/`;

        const allParams = this.processParameters(filters);
        return await trackPromise(Api.get(path, {params: allParams} ));
    }

    async listInvoices(filters?: Filters, expands?: Expands, pagination?: Paginated): Promise<AxiosResponse<PaginatedResult<AssetControl>>> {
        const path = `/api/purchase-order/invoice/list_invoices/`;

        const allParams = this.processParameters(filters, expands, pagination);
        return await trackPromise(Api.get(path, {params: allParams} ));
    }

  async get_export_status(hash: string, budget: boolean = true): Promise<AxiosResponse<{ status: number }>> {
    const path = `${this.path}/get_export_status/`;
    return await trackPromise(Api.get(path, {params: {hash, budget}}));
  }

  async export_xlsx(filters?: StockAndMaterialOutputFilter, expands?: Expands): Promise<AxiosResponse<{ hash: string }>> {
    const path = `${this.path}/export_xlsx/`;
    const allParams = this.processParameters(filters, expands);

    return await trackPromise(Api.get(path, {params: allParams}));
  }

  async get_invoice_dates(id: string): Promise<AxiosResponse<MonthYearOption[]>> {
    const path = `${this.path}/${id}/get_invoice_dates/`;
    return await trackPromise(Api.get(path));
  }

  async getTotalInvoices(filters?: AssetControlFilter): Promise<AxiosResponse<TotalInvoices>> {
    const path = `${this.path.replace('project_summary/', '')}invoice/group_by/`;
    const body = {
        "groups": [],
        "aggregates": [
            {
                "column": "total",
                "function": "sum"
            },
            {
                "column": "amtz_qtd",
                "function": "sum"
            }
        ]
    };
    const allParams = this.processParameters(filters);
    return await trackPromise(Api.post(path, body, {params: allParams}));
  }
}
